import { AlertOctagon, FlaskConical, Laptop, ServerCog, TestTube } from "lucide-react";

/* Environnement de la console. La production ne doit jamais pouvoir être
   confondue avec un bac à sable : elle seule porte un bandeau rouge pleine
   largeur, avec la mention « données réelles ». Les autres environnements ont
   une couleur froide et un libellé explicite. */

const ENVS = {
  production: { label: "Production", tone: "prod", icon: AlertOctagon, note: "Données réelles d'utilisateurs. Chaque action est journalisée et visible en audit." },
  staging: { label: "Staging", tone: "staging", icon: ServerCog, note: "Copie de recette. Les actions n'affectent aucun compte réel." },
  preview: { label: "Préproduction", tone: "preview", icon: FlaskConical, note: "Environnement éphémère de revue." },
  development: { label: "Développement", tone: "dev", icon: Laptop, note: "Instance locale." },
  test: { label: "Test", tone: "test", icon: TestTube, note: "Instance de test automatisé." },
};

export function detectEnv(explicit) {
  const declared = (explicit || process.env.REACT_APP_ENV || "").toLowerCase();
  if (ENVS[declared]) return { key: declared, ...ENVS[declared] };

  const host = typeof window === "undefined" ? "" : window.location.hostname;
  if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(host)) return { key: "development", ...ENVS.development };
  if (/(^|[.-])(staging|recette)\./.test(host) || host.startsWith("staging")) return { key: "staging", ...ENVS.staging };
  if (/(preview|pr-\d+|vercel\.app|up\.railway\.app)/.test(host)) return { key: "preview", ...ENVS.preview };
  // Par défaut on suppose la production : se tromper dans ce sens est le moins risqué.
  return { key: "production", ...ENVS.production };
}

// variant="band" : bandeau pleine largeur, réservé à la production.
// variant="badge" : pastille discrète pour la barre du haut.
export default function EnvBadge({ env, variant = "badge", note }) {
  const info = detectEnv(env);
  const Icon = info.icon;

  if (variant === "band") {
    if (info.key !== "production") return null;
    return (
      <div className={`adm-band is-${info.tone}`} role="note" data-testid="env-band">
        <Icon size={15} />
        <span className="adm-band-label">{info.label}</span>
        <span className="adm-band-note">{note || info.note}</span>
      </div>
    );
  }

  return (
    <span className={`adm-envtag is-${info.tone}`} title={note || info.note} data-testid="env-badge">
      <i aria-hidden="true" />{info.label}
    </span>
  );
}
